<script setup lang="ts">
  import type { ListOfferQuotationResource } from '@storefront/resources';

  interface Props {
    offer: any,
    quotations: ListOfferQuotationResource[],
  }

  defineProps<Props>();
</script>
<template>
  <div class="quotations">
    <SfTile>
      <div class="quotations__list">
        <OfferQuotation v-for="quotation in quotations" :offer="offer" :quotation="quotation" />
      </div>
    </SfTile>
  </div>
</template>
<style scoped lang="scss">
  .quotations {
    flex-grow: 0;
    width: 100%;

    &__list {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }
</style>
